import React from 'react';

export default function Breadcrumb({ title }) {
return (
<div className="breadcrumb-bar breadcrumb-bg-04 text-center">
    <div className="container">
        <div className="row">
            <div className="col-md-12 col-12">
                <h2 className="breadcrumb-title mb-2">{title}</h2>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center mb-0">
                        <li className="breadcrumb-item">
                            <i className="isax isax-home5"></i>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            {title}
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</div>
);
}
